import {
  OtoIndividualTripSteps,
  UpdateOtoIndividualTripStepsInput
} from '../../lib/types/models/enrollment/oto-individual-trip-steps'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

// Both legs go in one write so the backend checks the aller/retour rules against the same
// picture the parents saw. `submit: false` saves a draft, `submit: true` sends it to LEC.
export function updateOtoIndividualTripSteps({
  enrollmentId,
  ...data
}: UpdateOtoIndividualTripStepsInput & { enrollmentId: number }) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.updateOtoIndividualTripSteps.url, { id: enrollmentId }))
    .patch<OtoIndividualTripSteps, UpdateOtoIndividualTripStepsInput>(data)
}
